import React, { useEffect, useState } from 'react'
import { Modal, Icon, Button } from '@afterpaytouch/core'
import { useExternalLinkIframe } from '../../state'
import styles from './styles.module.css'
import { isUndefinedOrEmpty } from '@afterpay/utils'

const extractDomain = (url: string): string => {
  try {
    const urlObj = new URL(url, window.location.href)
    return urlObj.hostname
  } catch {
    return 'external site'
  }
}

export const ExternalLinkIframeModal = () => {
  const { url, isOpen, close } = useExternalLinkIframe()
  const isValidUrl = url !== null && !isUndefinedOrEmpty(url)
  const iframeTitle = isValidUrl ? `External content from ${extractDomain(url)}` : 'External content'
  const [announcement, setAnnouncement] = useState('')

  useEffect(() => {
    if (isOpen && isValidUrl) {
      const domain = extractDomain(url)
      setTimeout(() => {
        setAnnouncement(`Opening external link in modal: ${domain}`)
      }, 100)
    } else {
      setAnnouncement('')
    }
  }, [isOpen, url, isValidUrl])

  return (
    <>
      <div role='status' aria-live='polite' aria-atomic='true' className={styles.screenReaderOnly}>
        {announcement}
      </div>
      <Modal show={isOpen} onClose={close} onBackdropClick={close} noPadding size='Large' showCloseButton={false}>
        <div className={styles.closeButton}>
          <Button.Link type='button' size='Regular' aria-label='Close' onClick={close}>
            <Icon.Close size='Small' color='Neutral Black' />
          </Button.Link>
        </div>
        <Modal.Content>{isValidUrl && <iframe src={url} className={styles.iframe} title={iframeTitle} />}</Modal.Content>
      </Modal>
    </>
  )
}
